import {type FC, useEffect, useState} from "react";
import {Outlet, useNavigate} from "react-router-dom";
import Sidebar from "./Sidebar";
import MobileHeader from "./MobileHeader";
import type { NavItem } from "../types";
import { useScanHandler } from "../App";
import {useAuth} from "../context/AuthContext";

const ClientView: FC = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const { handleScan } = useScanHandler();
    const { user } = useAuth()
    const navigate  = useNavigate();

    useEffect(() => {
        if(user && !user.client){
            navigate("/admin/dashboard");
        }
    }, [user])

    const clientNavItems: NavItem[] = [
        { id: 'qrcodes', label: 'I Miei QR Code', path: '/client/qrcodes', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="6" height="6" x="3" y="3" rx="1"/><rect width="6" height="6" x="15" y="3" rx="1"/><rect width="6" height="6" x="3" y="15" rx="1"/><path d="M15 15h6v6h-6z"/></svg> },
        { id: 'oneshots', label: 'One Shot', path: '/client/oneshots', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="6" height="6" x="3" y="3" rx="1"/><rect width="6" height="6" x="15" y="3" rx="1"/><rect width="6" height="6" x="3" y="15" rx="1"/><path d="M15 15h6v6h-6z"/></svg> },
        { id: 'badges', label: 'Badge', path: '/client/badges', badge: 'new', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="8" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="16" y2="21"/></svg> },
        { id: 'scan', label: 'Scansiona', path: '/client/scan', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 12v5h12V8H9v4Z"/><path d="M18 8V5"/><path d="M14 8V5"/></svg> },
        { id: 'info', label: 'Info QR', path: '/client/info', badge: 'new', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg> },
    ];

    return (
        <div className="flex h-screen bg-slate-900 overflow-hidden">
            {/* Overlay Mobile */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/60 z-40 lg:hidden backdrop-blur-sm transition-opacity"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div className={`
                fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ease-in-out
                lg:static lg:translate-x-0 lg:inset-auto lg:flex-shrink-0
                ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            `}>
                <Sidebar
                    brandIcon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>}
                    brandName="Area Cliente"
                    navItems={clientNavItems}
                    sidebarColor="amber"
                    onLinkClick={() => setSidebarOpen(false)}
                />
            </div>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <MobileHeader onMenuClick={() => setSidebarOpen(true)} title="Area Cliente"/>
                <main className="flex-1 overflow-y-auto p-4 sm:p-8 scroll-smooth">
                    <div className="max-w-7xl mx-auto">
                        <Outlet context={{ handleScan }}/>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default ClientView;